export default __webpack_public_path__ + "media/music/851af8a9d226b487083942a91fc03a8f.mp3";